import { gql } from '@apollo/client';

export const CHECK_DATA_STALE_BY_PLANNING_POOL = gql`
    query CheckDataStaleByPlanningPool(
        $warehouseId: Long!
        $areaIds: [Long!]!
        $totalParcels: Int!
        $areaDspMappings: [AreaDspMappingInput!]!
    ) {
        checkDataStaleByPlanningPool(
            warehouseId: $warehouseId
            areaIds: $areaIds
            totalParcels: $totalParcels
            areaDspMappings: $areaDspMappings
        ) {
            parcelsStale
            dspStaleAreas {
                areaId
                expectedDspId
                actualDspId
            }
        }
    }
`;

export interface DspStaleArea {
    areaId: number;
    expectedDspId: number;
    actualDspId: number | null;
}

export interface DataStaleCheckResult {
    parcelsStale: boolean;
    dspStaleAreas: DspStaleArea[];
}

export interface CheckDataStaleByPlanningPoolResponse {
    checkDataStaleByPlanningPool: DataStaleCheckResult;
}

export interface AreaDspMapping {
    areaId: number;
    dspId: number;
}

export interface CheckDataStaleByPlanningPoolVariables {
    warehouseId: number;
    areaIds: number[];
    totalParcels: number;
    areaDspMappings: AreaDspMapping[];
}
